import React, { useEffect, useState } from 'react';

import R from 'ramda';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';

import Title from 'react-bulma-companion/lib/Title';

import {
  TextInput,
  TextArea,
  Phone,
  DateField,
  DropDown,
  Checkbox,
  Radio,
  SecureText
} from '_molecules/FormInputs';

import SubInfo from '_molecules/SubInfo/SubInfo';

import { upsertSurveyAnswer } from '_actions/answers';

import { filterVisibleComponents } from '_utils/survey';


export default function SurveyBody({ survey_id, title, components, sub_info, err = '' }) {
  const dispatch = useDispatch();

  const { answers } = useSelector(R.pick(["answers"]));

  const [loading, setLoading] = useState(true); //TODO: wait until all components mount to display

  const updateValue = (id, value, encrypted_field = false) => {
    dispatch(upsertSurveyAnswer({
      sID: survey_id,
      qID: id,
      answer: value,
      encrypted_field: encrypted_field
    }));
  }

  const [visibleComponents, setVisibleComponents] = useState(filterVisibleComponents(answers, components))

  useEffect(() => {
    setVisibleComponents(filterVisibleComponents(answers, components));
  }, [components, answers]);

  useEffect(() => {
    for(const c in components) {
      if(components[c].defaultValue) {
        updateValue(components[c].id, components[c].defaultValue);
      }
    }
  }, [components])

  return (
    <div className="survey-body">
      <Title size="3">{title}</Title>

      <div className="input-group">
        {visibleComponents.map((component, itr, key) => {
          switch (component.type) {
            case 'DropDown':
              return <DropDown
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                placeholder={component.placeholder}
                options={component.options}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            case 'Checkbox':
              return <Checkbox
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                options={component.options}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            case 'Radio':
              return <Radio
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                options={component.options}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            case 'DateField':
              return <DateField
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                placeholder={component.placeholder}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            case 'Phone':
              return <Phone
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                placeholder={component.placeholder}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            case 'SecureText':
              return <SecureText
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                placeholder={component.placeholder}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            case 'TextArea':
              return <TextArea
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                placeholder={component.placeholder}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                autoFocus={itr == 0}
                classes={component.classes}
              />;

            default:
              return <TextInput
                key={component.id}
                id={component.id}
                required={component.required}
                name={component.name}
                label={component.label}
                placeholder={component.placeholder}
                defaultValue={component.defaultValue ?? ''}
                updateValue={updateValue}
                validators={component.validators}
                autoFocus={itr == 0}
                classes={component.classes}
              />;
          }
        })}
      </div>

      {sub_info && sub_info.length > 0 && <SubInfo className={sub_info.length > 222 ? "long_message" : ''} message={sub_info} />}
    </div>
  );
}